export default {"src":"/_next/static/media/infoIconGray.3d4bd89c.svg","height":13,"width":13};